module.exports = __webpack_public_path__ + "assets/img/d2.754bdef3.png";